import { useUiStore } from '../store/ui';

export function ToastRenderer() {
  const { toasts, dismissToast } = useUiStore();
  if (toasts.length === 0) return null;
  return (
    <div className="toast-stack" aria-live="polite">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast toast-${t.kind}`}
          onClick={() => dismissToast(t.id)}
          role="alert"
        >
          <div className="toast-bubble">
            {t.kind === 'success' ? '✓' : t.kind === 'danger' ? '✕' : t.kind === 'warning' ? '!' : t.kind === 'info' ? 'ℹ' : '•'}
          </div>
          <div className="toast-content">
            <div className="toast-title">{t.title}</div>
            {t.message ? <div className="toast-message">{t.message}</div> : null}
          </div>
          <button
            className="toast-close"
            onClick={(e) => { e.stopPropagation(); dismissToast(t.id); }}
            aria-label="Dismiss"
          >
            {'×'}
          </button>
        </div>
      ))}
    </div>
  );
}

